import React, { FC } from 'react';
import { ReactComponent as RoundBtn } from '../../../assets/Common/RoundBtn.svg';

export const RoundBtnIcon: FC = () => <RoundBtn />;
